var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28,
    clipPath: "url(#clip0_287_10291)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_287_10291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.583 220.036C657.265 428.813 596.829 637.452 883.885 448.453C1267.68 195.759 917.036 -671.739 770.488 -689.501C426.62 -731.178 -290.497 -42.5728 42.8004 -53.1854C183.215 -57.6564 363.901 11.2597 510.583 220.036Z",
    fill: "url(#paint0_linear_287_10291)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_f_287_10291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1368.17 612.613C1607.07 927.859 1557.17 1208.8 1926.27 992.566C2419.76 703.461 1787.99 -563.8 1580.74 -612.701C1094.44 -727.445 208.013 114.53 670.964 154.629C866 171.522 1129.27 297.367 1368.17 612.613Z",
    fill: "#0078FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_287_10291",
    x: -243.384,
    y: -891.319,
    width: 1501.02,
    height: 1613.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_287_10291"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_287_10291",
    x: 341.087,
    y: -823.437,
    width: 1969.32,
    height: 2092.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_287_10291"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_10291",
    x1: 6540.95,
    y1: 5222.69,
    x2: 7836.08,
    y2: 3703.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_10291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "matrix(-1 0 0 1 1440 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientCloud);
export default __webpack_public_path__ + "static/media/gradient-cloud.a7f699da7c8b880c632eebf659983a1e.svg";
export { ForwardRef as ReactComponent };